<template>
  <div class="play-btn" :class="{ playing: isPlaying }" @click="handleClick">
    <transition name="icon-fade" mode="out-in">
      <Pause v-if="isPlaying" key="pause" class="icon pause-icon" />
      <Play v-else key="play" class="icon play-icon" />
    </transition>
  </div>
</template>

<script lang="ts" setup>
import Pause from './assets/icon-pause.svg?component';
import Play from './assets/icon-play.svg?component';

interface Props {
  playing?: boolean;
}

interface Emits {
  (e: 'play'): void;
  (e: 'pause'): void;
  (e: 'toggle', playing: boolean): void;
}

const props = withDefaults(defineProps<Props>(), {
  playing: false,
});

const emit = defineEmits<Emits>();

// 直接使用 props.playing，不维护内部状态
const isPlaying = computed(() => props.playing);

const handleClick = () => {
  // 不修改内部状态，只发送事件让父组件处理
  // if (isPlaying.value) {
  //   emit('pause')
  // } else {
  //   emit('play')
  // }

  emit('toggle', !isPlaying.value);
};
</script>

<style lang="scss" scoped>
.play-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  background: transparent; // 透明背景
  // CSS hover 效果
  &:hover {
    background-color: var(--white-1);
  }
}

.icon {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: all 0.2s ease;
}

// 图标切换动画
.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: opacity 0.2s ease;
}

.icon-fade-enter-from,
.icon-fade-leave-to {
  opacity: 0;
}
</style>
